import React from 'react';
import {MainBannerComponent, ServicesDescriptionComponent, BannerComponent, MemberComponent, ContactDetailsComponent, TextComponent} from '../../../../common/CMS/components';

export const Content2 = (props) => {
  const {mainBannerSection, bannerSection, textSectionOne, textSectionTwo, servicesDescriptionSection, memberSection, contactDetailsSection } = props.data.content;

  return <div className="content-two">

    { mainBannerSection && <MainBannerComponent content={mainBannerSection} /> }

    { textSectionOne.columns && <TextComponent content={textSectionOne.columns}/> }

    { textSectionTwo.columns && <TextComponent content={textSectionTwo.columns}/> }

    <ServicesDescriptionComponent header={servicesDescriptionSection.header}
                                  intro={servicesDescriptionSection.introduction}
                                  linkColor={servicesDescriptionSection.linkColor}
                                  services={servicesDescriptionSection.services} />

    { bannerSection && <BannerComponent {...bannerSection} /> }

    { memberSection && <MemberComponent content={memberSection} /> }

    { contactDetailsSection && <ContactDetailsComponent content={contactDetailsSection} /> }

  </div>

};



// WEBPACK FOOTER //
// src/client/components/site/features/partnerships/templates/Content2.js